<template>
  <div>
    <tabs @change="changeTab">
      <tab title="历史记录" name="1">
        <div class="list-con" v-if="history.length>0">
          <div class="common_item" v-for="item in history" :key="item.orderId">
            <CellInfo :info="item"></CellInfo>
          </div>
        </div>
        <empty v-else description="暂无数据" />
      </tab>
      <tab title="已取消" name="3">
        <div class="list-con" v-if="cancelList.length>0">
          <div class="common_item cancel_item" v-for="item in cancelList" :key="item.orderId">
            <CellInfo :info="item" type="cancel"></CellInfo>
          </div>
        </div>
        <empty v-else description="暂无数据" />
      </tab>
      <tab title="过期券" name="2">
        <div class="list-con" v-if="staffList.length>0">
          <div class="common_item" v-for="item in staffList" :key="item.personCode">
            <CellExpire :info="item"></CellExpire>
          </div>
        </div>
        <empty v-else description="暂无数据" />
      </tab>
    </tabs>
  </div>
</template>

<script>
import CellExpire from './components/cellExpire';
import CellInfo from './components/cellInfo';
import { Tab, Tabs, Empty } from 'vant';
import { queryCurrentUserExpireList, queryCurrentUserOrders, queryCancelCurrentUserOrders } from '@/api/birthday';

export default {

  components: {
    CellExpire,
    CellInfo,
    Tabs,
    Tab,
    Empty,
  },

  data() {
    return {
      history: [],
      cancelList: [],
      staffList: [],
    };
  },

  mounted() {
    this.initHistory();
  },

  methods: {
    changeTab(e) {
      switch (e) {
        case '1':
          this.initHistory();
          break;
        case '2':
          this.initExpire();
          break;
        case '3':
          this.initCancelOrder();
          break;
        default:
          break;
      }
    },

    /**
     * 初始化历史订单
     */
    initHistory() {
      queryCurrentUserOrders().then(resp => {
        console.log(resp);
        this.history = resp || [];
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      });
    },

    /**
     * 初始化取消订单
     */
    initCancelOrder() {
      queryCancelCurrentUserOrders().then(resp => {
        this.cancelList = resp;
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      })
    },

    /**
     * 初始化过期券
     */
    initExpire() {
      queryCurrentUserExpireList().then(resp => {
        this.staffList = resp;
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      });
    },

  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.list-con {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  padding: 20px 40px;
  .common_item {
    padding: 20px;
    background-color: #fff;
    border-radius: 20px;
    font-size: 28px;
    margin-bottom: 20px;
  }
  .cancel_item {
    position: relative;
  }
  .cancel_item::after {
    content: ' ';
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 140px;
    height: 120px;
    background-image: url('https://web-data.zmlearn.com/image/pDaqCgLzb6tRx9Js4A864y/cancel.png');
    background-size: 100% 100%;
  }
}
</style>